import moment from "moment";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Field, formValueSelector, getFormInitialValues } from "redux-form";
import {
    DOCUMENTATION_UPDATE_SECTION,
    FORM_FIELD_DOCUMENTATION_UPDATE,
    FORM_FIELD_DOCUMENTATION_UPDATE_JUSTIFICATION,
    FORM_FIELD_ESTIMATED_DATE,
    FORM_LABEL_DOCUMENTATION_UPDATE,
    FORM_LABEL_DOCUMENTATION_UPDATE_JUSTIFICATION,
    FORM_LABEL_ESTIMATED_DATE,
} from "../../../../../../constants/formConstants";
import {
    documentationUpdate,
    NO,
    YES,
} from "../../../../../../constants/Utils";
import formMessages from "../../../../../../intl/afterSales/formMessages";
import commonMessages from "../../../../../../intl/common/commonMessages";
import DatePickerComponent from "../../../../../common/datePicker/DatePickerComponent";
import { InputFieldWithValidation } from "../../../../../common/InputFieldWithValidation";
import InputSelectFieldWithValidation from "../../../../../common/InputSelectFieldWithValidation";
import BorderRadius from "../../../../../common/styled/BorderRadius";

const colClassName = "col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2";

const DocumentationUpdateSection = (props) => {
    const { documentationUpdateValue, reqFields, userRights, readOnly } = props;

    return (
        <>
            <h3 className="text-left ml-4">
                <FormattedMessage
                    {...formMessages.DOCUMENTATION_UPDATE_SECTION}
                />
            </h3>
            <BorderRadius
                size={5}
                className="border border-secondary px-4 py-2 bg-white"
            >
                <div className="form-row">
                    <div className={colClassName}>
                        <InputSelectFieldWithValidation
                            label={
                                formMessages[FORM_LABEL_DOCUMENTATION_UPDATE]
                            }
                            field={FORM_FIELD_DOCUMENTATION_UPDATE}
                            isRequired={reqFields.includes(
                                FORM_FIELD_DOCUMENTATION_UPDATE,
                            )}
                            isDisabled={
                                readOnly ||
                                !userRights.canEditInternalDocumentationUpdate
                            }
                            options={documentationUpdate}
                            intlMessages={commonMessages}
                        />
                    </div>
                    {documentationUpdateValue === YES && (
                        <div className={colClassName}>
                            <Field
                                component={DatePickerComponent}
                                label={formMessages[FORM_LABEL_ESTIMATED_DATE]}
                                name={FORM_FIELD_ESTIMATED_DATE}
                                isRequired={reqFields.includes(
                                    FORM_FIELD_ESTIMATED_DATE,
                                )}
                                isDisabled={
                                    readOnly ||
                                    !userRights.canEditInternalDocumentationUpdate
                                }
                                selectsEnd
                                isClearable
                                parse={(e) =>
                                    e ? moment(e).format("YYYY-MM-DD") : null
                                }
                            />
                        </div>
                    )}
                    {documentationUpdateValue === NO && (
                        <div className={colClassName}>
                            <InputFieldWithValidation
                                label={
                                    formMessages[
                                        FORM_LABEL_DOCUMENTATION_UPDATE_JUSTIFICATION
                                    ]
                                }
                                name={
                                    FORM_FIELD_DOCUMENTATION_UPDATE_JUSTIFICATION
                                }
                                isRequired={reqFields.includes(
                                    FORM_FIELD_DOCUMENTATION_UPDATE_JUSTIFICATION,
                                )}
                                isDisabled={
                                    readOnly ||
                                    !userRights.canEditInternalDocumentationUpdate
                                }
                                maxLength={500}
                                isSmall
                            />
                        </div>
                    )}
                </div>
            </BorderRadius>
        </>
    );
};

const mapStateToProps = (state, props) => ({
    initialValues: getFormInitialValues(props.form)(state),
    documentationUpdateValue: formValueSelector(props.form)(
        state,
        `${DOCUMENTATION_UPDATE_SECTION}.${FORM_FIELD_DOCUMENTATION_UPDATE}`,
    ),
});

const mapDispatchToProps = () => ({});

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(DocumentationUpdateSection),
);

